import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

/**
 * Redirects first-time users to `/welcome` before any main-app route renders.
 * Wraps the AppLayout route group only (welcome lives outside MainLayout).
 */
export function WelcomeGate() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || !user) {
    return <Outlet />;
  }

  const hasSeenOnboarding = user.preference?.hasSeenOnboarding;
  if (!hasSeenOnboarding) {
    return <Navigate to="/welcome" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
